import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "main-section" }
const _hoisted_2 = { class: "content-section" }
const _hoisted_3 = { class: "content-section" }
const _hoisted_4 = { class: "game-description full-width" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Accent = _resolveComponent("Accent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("section", { class: "content-section" }, [
      _createElementVNode("video", {
        class: "media-video full-width",
        controls: "",
        "aria-hidden": "true",
        poster: "/insheepsclothing/src/img/thumb_insheepsclothing_trailer.jpg"
      }, [
        _createElementVNode("source", {
          src: "/insheepsclothing/src/mp4/insheepsclothing_trailer_c.mp4",
          type: "video/mp4"
        }),
        _createTextVNode(" Your browser does not support the video tag. ")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "title" }, "Things I learned", -1)),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectData.learn, (task, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "game-description game-list",
            key: index
          }, _toDisplayString(task), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "title full-width" }, "Camera Mechanic", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "game-description full-width" }, " In the game, one of your objectives is to take pictures of certain points of interests. You have to pick up a camera in the game, hold it and take a picture. Once a picture has been taken, the game determines if the target was in the picture. The player receives points based on how well it was in the picture. Regardless of whether or not the target was in the picture, a picture is printed out and the player has to deposit the picture in a suitcase to receive the points. ", -1)),
      _createElementVNode("p", _hoisted_4, [
        _cache[2] || (_cache[2] = _createTextVNode(" We use a second camera for the physical in-game camera and project it onto a render texture. If the user takes a picture, we do a simple ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("AABB test against the bounds of the target")
          ])),
          _: 1
        }),
        _cache[3] || (_cache[3] = _createTextVNode(" in question to determine if it has been hit or not. Once a picture has been taken, a grabbable object spawns out of the camera that has its physics disabled until the player picks it up for the first time. "))
      ])
    ])
  ]))
}